/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

/** 
 * Custom properties for employee component.
 * Can be populated by parent element. 
 */
type EmployeeImageProps = {
    imageName:  string | undefined,
    cssClass?:  string | undefined, 
    altText?:   string | undefined
}

const EmployeeImage = ({ imageName, cssClass, altText }: EmployeeImageProps) =>
{
    const [image, SetImage] = useState<string>("/default-avatar.png");

    useEffect(() => {
        /* Set Image for employee */
        SetImage("/employees/" + imageName + ".jpg")
    }, [])

    return (
        <img onError={e => SetImage("/default-avatar.png")} src={image} className={cssClass ? cssClass : "img-thumbnail"} alt={altText ? altText : "Employee-Image " + imageName} /> 
    )
}

export default EmployeeImage;